<section class="main">
    <h3>Add unit quota</h3>

    <div class="mb-3  radioInput">
        <div class="form-group">
            <input [checked]="showQuotaStatus" (change)="changeQutoa($event)" name="name" type="radio">
            <label class="me-2 ms-2">One day event</label>
        </div>
        <div class="form-group">
            <input (change)="changeQutoa($event)" name="name" type="radio">
            <label class="me-2 ms-2">Weekly schedule</label>
        </div>
    </div>

    <section *ngIf="showQuotaStatus">
        <div>
            <label>Date</label>
            <div class="mb-3 d-flex align-items-center datePicker">
                <input [(ngModel)]="quotaData" class="form-control" placeholder="yyyy/mm/dd" [matDatepicker]="picker">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </div>
        </div>
        <div class="mb-3">
            <label>Priority</label>
            <div class="dropdown mb-0 ">
                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    {{Choose_Priority}}
                    <img src="assets/images/mangeunit/arrow.png">
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <li (click)="getPriority('Override ALL',1)"><a class="dropdown-item">Override ALL</a></li>
                    <li (click)="getPriority('High Priority',2)"><a class="dropdown-item">High Priority</a></li>
                    <li (click)="getPriority('Standard',3)"><a class="dropdown-item">Standard</a></li>
                    <li (click)="getPriority('Low Priority',4)"><a class="dropdown-item">Low Priority</a></li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Quantity</label>
                    <input type="number" [(ngModel)]="quotaQuantity" class="form-control">
                </div>
            </div>
        </div>
        <div *ngIf="erorrSchduleMassage" class="alert alert-danger" role="alert">
                please fill all Data
            </div>
        <div class="addUnits d-flex justify-content-end mt-5 mb-2">
            <div>
                <button class="btn me-2">Cancel</button>
                <button (click)="addQuotaByDay()" class="btn addUnit">Add quota</button>
            </div>
        </div>
    </section>

    <section *ngIf="!showQuotaStatus">
        <div class="row">
            <div class="col">
                <label>From</label>
                <div class="mb-3 d-flex align-items-center datePicker">
                    <input [(ngModel)]="valid_fromSchdule" class="form-control" placeholder="yyyy/mm/dd"
                        [matDatepicker]="pickerfrom">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerfrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerfrom></mat-datepicker>
                </div>
            </div>
            <div class="col">
                <label>To</label>
                <div class="mb-3 d-flex align-items-center datePicker">
                    <input [(ngModel)]="valid_toSchdule" class="form-control" placeholder="yyyy/mm/dd"
                        [matDatepicker]="pickerto">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerto"></mat-datepicker-toggle>
                    <mat-datepicker #pickerto></mat-datepicker>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <label>Priority</label>
            <div class="dropdown mb-0 ">
                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    {{Choose_Priority_schdule}}
                    <img src="assets/images/mangeunit/arrow.png">
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                    <li (click)="getPrioritySchudle('Override ALL',1)"><a class="dropdown-item">Override ALL</a></li>
                    <li (click)="getPrioritySchudle('High Priority',2)"><a class="dropdown-item">High Priority</a></li>
                    <li (click)="getPrioritySchudle('Standard',3)"><a class="dropdown-item">Standard</a></li>
                    <li (click)="getPrioritySchudle('Low Priority',4)"><a class="dropdown-item">Low Priority</a></li>
                </ul>
            </div>
        </div>
        <div>
            <form [formGroup]="weekDays">
                <p>Quantity</p>
                <div class="row">
                    <div class="col-2 mb-2" *ngFor="let item of weeksArr">
                        <label>{{item.name}}</label>
                        <input [formControlName]="item.title" value="{{item.value}}" type="number" class="form-control">
                    </div>
                </div>
            </form>
        </div>

        <div *ngIf="erorrSchduleMassage" class="alert alert-danger" role="alert">
            please fill all Data
        </div>

        <div class="addUnits d-flex justify-content-end mt-5 mb-2">
            <div>
                <button class="btn me-2">Cancel</button>
                <button (click)="addQuotaSchudle()" class="btn addUnit">Add quota</button>
            </div>
        </div>
    </section>


</section>